// appConfigSchemas.js
// Each package defines its own fields array.
// field types: 'url' | 'tags' | 'toggle' | 'radio'

export const APP_CONFIG_SCHEMAS = {
    'com.android.chrome': {
      defaultValues: {
        HomepageLocation: '',
        URLBlocklist: [],
        URLAllowlist: [],
        SafeBrowsingEnabled: true,
        SafeSitesFilterBehavior: 1,
      },
      fields: [
        {
          key: 'HomepageLocation',
          type: 'url',
          label: 'Homepage URL',
          icon: 'fas fa-home',
          hint: 'The browser will open this URL as the homepage.',
          placeholder: 'https://example.com',
        },
        {
          key: 'URLBlocklist',
          type: 'tags',
          label: 'URL Blocklist',
          icon: 'fas fa-ban',
          iconClass: 'text-danger',
          hint: 'Use <code>*</code> to block all URLs (then allowlist exceptions below).',
          placeholder: 'e.g. * or https://example.com',
        },
        {
          key: 'URLAllowlist',
          type: 'tags',
          label: 'URL Allowlist',
          icon: 'fas fa-check-circle',
          iconClass: 'text-success',
          hint: 'Sites always accessible, even if blocked above.',
          placeholder: 'https://example.com',
        },
        {
          key: 'SafeBrowsingEnabled',
          type: 'toggle',
          label: 'Safe Browsing',
          icon: 'fas fa-shield-alt',
          iconClass: 'text-primary',
          description: 'Protect against phishing, malware, and dangerous sites',
        },
        {
          key: 'SafeSitesFilterBehavior',
          type: 'radio',
          label: 'Safe Sites Filter',
          icon: 'fas fa-filter',
          iconClass: 'text-primary',
          options: [
            { value: 0, title: 'Disabled', desc: 'No explicit content filtering applied' },
            { value: 1, title: 'Enabled',  desc: 'Filter explicit and adult content' },
          ],
        },
      ],
    },
    'com.google.android.youtube': {
      defaultValues: {
        restricted_mode: 'Strict',
      },
      fields: [
        {
          key: 'restricted_mode',
          type: 'select',
          label: 'Restriction Mode',
          icon: 'fas fa-filter',
          iconClass: 'text-primary',
          options: [
            { value: "Strict", title: 'Strict', desc: 'Forces the highest level of filtering' },
            { value: "Moderate", title: 'Moderate',  desc: 'A lighter filter' },
            { value: "None", title: 'None',  desc: 'No filtering' },
          ],
        },
      ],
    },
  
    // Add more packages here easily:
    // 'com.android.youtube': { defaultValues: { ... }, fields: [ ... ] },
};